<template>
  <div>
    <bs-card class="card-info" :icon="icon" :label="labels.name">
      <template v-slot:header>
        <bs-button class="btn-sm btn-info" @click="create">{{ labels.assign }}</bs-button>
      </template>
      <bs-table v-bind="{dataLength, loading}" :cols="2">
        <template v-slot:thead>
          <tr>
            <bs-th :label="$tc('labels.project_worker', 0)" :sortable="resourceState.sort" :col="'name'" @click="applySort"></bs-th>
            <bs-th scope="col"></bs-th>
          </tr>
        </template>
        <tr v-for="r in resources.data" :key="r.id">
          <td>
            <avatar class="mr-1" :user="r" showName />
          </td>
          <td class="t1">
            <bs-action :icon="['fal', 'trash']" :tip="labels.delete" class="btn-danger" @click="destroy(r)"></bs-action>
          </td>
        </tr>
        <template v-slot:tfoot>
          <pagination :data="resources" :state="resourceState" @pushPage="index" :counts="[5, 10]"></pagination>
        </template>
      </bs-table>
    </bs-card>
    <portal to="app-modal">
      <bs-modal :name="'create-' + $options.name" :label="resource.id ? labels.edit : labels.create">
        <bs-form :submit="$t('labels.submit')" @submit="submit">
          <template v-slot:default="{ error }">
            <tuxedo-select :name="'users'" :label="$tc('labels.user', 0)" v-model="resource.users" :options="users" :insistLabel="'name'" :multi="true" :error="error" />
          </template>
        </bs-form>
      </bs-modal>
      <bs-modal :name="'destroy-' + $options.name" :label="labels.delete">
        <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
          {{ $t('messages.delete', { resource: camelToSpace(singular($options.name)) }) }}
        </bs-form>
      </bs-modal>
    </portal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { resourceControl } from '../../mixins/resourceControl'

export default {
  name: 'ProjectWorkers',
  mixins: [resourceControl],
  props: ['project'],
  data () {
    return {
      icon: ['fal', 'books'],
      resource: {
        users: []
      }
    }
  },
  computed: {
    ...mapState({
      resources: state => state.projectWorkers,
      resourceState: state => state.projectWorkersState,
      users: state => state.usersStore
    }),
    apiTarget () { return ['projects', this.project, 'workers'] }
  }
}
</script>
